<template>
  <div>
    <p class="dialog-title">必填信息</p>
    <div style="padding: 0 60px; margin-bottom: 10px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">姓名</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.name) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">身份证</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.numberId) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">联系电话</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.phone) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">运维公司</el-col>
          <el-col :span="18">{{
            $judgeEmpty(formData.maintainCompany)
          }}</el-col>
        </el-col>
      </el-row>
    </div>
    <p class="dialog-title">非必填信息</p>
    <div style="padding: 0 60px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">性别</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.sex) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">学历</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.educationStr) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">所属代维专业</el-col>
          <el-col :span="18">{{
            $judgeEmpty(formData.belongMaintainStr)
          }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">合同到期时间</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.contractTime) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">在职状态</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.situation) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">民族</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.nation) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">籍贯</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.hometown) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">家庭住址</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.addr) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">入职时间</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.entryTime) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">具备技能</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.skill) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">岗位职责</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.postDuty) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">购买保险情况</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.insurance) }}</el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="6" class="dialog-label">备注</el-col>
          <el-col :span="18">{{ $judgeEmpty(formData.remark) }}</el-col>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintainForm",
  props: {
    formData: {
      type: Object,
      required: true, //要求父组件必传
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
</style>
